<template>
    <b-container fluid>
        <b-row>
            <b-col class="pl-0">
                <b-button variant="link" @click="save()">Сохранить</b-button>
                <b-button variant="link" @click="$router.go(-1)">Закрыть</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="3">
                <b-form-group label="Штрихкод">
                    <b-form-input disabled v-model="entity.barcode"/>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
                <b-form-group label="DLV PlaceId">
                    <b-form-input disabled v-model="entity.dlvPlaceId"/>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
                <b-form-group label="Принято">
                    <b-form-checkbox disabled v-model="entity.accepted"/>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
                <b-button @click="acceptPlace">Принять место</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="3">
                <b-form-group label="Вес">
                    <b-form-input :disabled="entity.accepted" v-model="entity.dimension.weight"/>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
                <b-form-group label="Ширина">
                    <b-form-input  :disabled="entity.accepted" v-model="entity.dimension.width"/>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
                <b-form-group label="Длинна">
                    <b-form-input  :disabled="entity.accepted" v-model="entity.dimension.height"/>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
                <b-form-group label="Глубина">
                    <b-form-input  :disabled="entity.accepted" v-model="entity.dimension.depth"/>
                </b-form-group>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "PlaceEditor",
        created() {
            if (this.$route.params.id) {
                this.getEntity(this.$route.params.id);
            }

        },
        data() {
            return {
                entity: {
                    id: null,
                    barcode: null,
                    dlvPlaceId: null,
                    accepted: null,
                    dimension: {
                        weight: null,
                        width: null,
                        height: null,
                        depth: null,
                    }
                },
                shipments: [],
                tableFields: [
                    {
                        key: 'num',
                        label: 'Номер'
                    }, {
                        key: 'shipmentType',
                        label: 'Тип'
                    }, {
                        key: 'dlvLogin',
                        label: 'Аккаунт'
                    }, {
                        key: 'status',
                        label: 'Статус',
                    }, {
                        key: 'courierCode',
                        label: 'Служба доставки',
                    }, {
                        key: 'courierNum',
                        label: 'Номер отслеживания КС',
                    },{
                        key: 'dlvId',
                        label: 'DLV Id',
                    }, {
                        key: 'actions',
                        label: 'Действия'
                    }
                ],


            }
        },
        methods: {
            save() {
                this.$http.post(this.$root.apiUrl + '/api/place', this.entity, {headers: this.$root.getHeaders()})
                    .then(response => {
                        if (response.body.success) {
                            this.$router.push("/places");
                        } else {
                            alert(response.body.errors.map(error => error.message).reduce((acc, value) => acc + '<br>' + value));
                        }
                    }, response => {
                        this.$root.handleErrorResponse(response);
                    });
            },
            getEntity(id) {
                this.$http.get(this.$root.apiUrl + '/api/place/' + id, {headers: this.$root.getHeaders()})
                    .then(response => {
                            if (response.body.success) {
                                this.entity = response.body.entity;
                                this.getHistory(this.entity.syncRecord.id);
                            } else {
                                alert(response.body.errors.map(error => error.message).reduce((acc, value) => acc + '<br>' + value));
                            }
                        },
                        response => {
                            this.$root.handleErrorResponse(response);
                        }
                    );
            },
            acceptPlace() {
                this.$http.post(this.$root.apiUrl + '/api/acceptPlace',
                    {
                        placeId: this.entity.dlvPlaceId,
                        dimension: this.entity.dimension
                    }, {headers: this.$root.getHeaders()})
                    .then(response => {
                        if (response.body.success) {
                            this.getEntity(this.entity.id);
                        } else {
                            alert(response.body.errors.map(error => error.message).reduce((acc, value) => acc + '<br>' + value));
                        }
                    }, response => {
                        this.$root.handleErrorResponse(response);
                    });
            }
        }
    }
</script>

<style scoped>
</style>